
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'
import moment from 'moment'

function transformer({ affectedId, signatures, hour }) {
  return {
    affected: affectedId,
    firms: signatures,
    hour: moment(hour).format("HH:mm")
  }
}

/* distributeImages */
export default (payload) => {
  return errorHandler(Vue.$http.post(`purchase/quantification/certificate/`,
    transformer(payload)))
    .then(response => {
      const data = response.data
      return data
    }).catch(err => {
      if (err && err.response) {
        const response = err.response
        if (response && response.data && response.data.Error) {
          throw response.data.Error
        }
      }
      throw err
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/createDeliveryReceiptCertification.js